module.exports = __webpack_public_path__ + "assets/img/logo.ebf7be63.jpeg";